// extracted by mini-css-extract-plugin
export default {"breadcrumContainer":"RenderBreadcrum_breadcrumContainer__Fb0rX"};